import { render, staticRenderFns } from "./EditableTable.vue?vue&type=template&id=0ff85268&scoped=true"
import script from "./EditableTable.vue?vue&type=script&lang=ts"
export * from "./EditableTable.vue?vue&type=script&lang=ts"
import style0 from "./EditableTable.vue?vue&type=style&index=0&id=0ff85268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff85268",
  null
  
)

export default component.exports